export default __webpack_public_path__ + "static/media/comment.f5537241.jpg";